module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("auto-contain auto-contain__" + _vm.type)
  }, [(_vm.placeholder) ? _c('span', {
    staticClass: "auto-placeholder"
  }, [_vm._v(_vm._s(_vm.placeholder)), (_vm.required) ? _c('span', {
    staticClass: "auto-placeholder__required"
  }, [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "height": _vm.height,
      "solo": _vm.solo,
      "dense": _vm.dense,
      "filled": _vm.filled,
      "rounded": _vm.rounded,
      "chips": _vm.chips,
      "deletable-chips": _vm.deletable_chips,
      "multiple": _vm.multiple,
      "small-chips": _vm.small_chips,
      "value": _vm.value,
      "input-value": _vm.value,
      "hide-details": _vm.hide_details,
      "items": _vm.items,
      "clearable": _vm.clearable,
      "label": _vm.label,
      "rules": _vm.rules || [],
      "color": _vm.color,
      "item-value": _vm.item_value,
      "item-text": _vm.item_text
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event)
      },
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4548bdac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/UiAuto.vue
// module id = 354
// module chunks = 2